import React from 'react';
import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

import Tooltip from '../../../../CoreWrappers/Tooltip';

const prop = 'accountName';

export const config = (labels) => ({
	id: `${prop}Column`,
	label: labels.columns[prop],
	propName: 'accountName',
	width: 'minmax(var(--px-410), 3fr)',
	sortBy: prop,
	customCell: (item) => {
		const renderAccount = (isDisabled = false) => {
			const props = {};
			if (isDisabled) props.className = 'disabled';
			return (
				<StyledDisabledOutputText body2 light {...props}>
					{item.accountName}
				</StyledDisabledOutputText>
			);
		};

		if (item?.isDisabled) {
			const renderTrigger = () => {
				return renderAccount(true);
			};
			const toolTipProps = {
				trigger: renderTrigger(),
				allowClick: true
			};
			return (
				<Tooltip {...toolTipProps}>
					<OutputText body2 light maxWidth="var(--px-700)" wordBreak={true}>
						{labels.relateAccountTableDisabledRowToolTip}
					</OutputText>
				</Tooltip>
			);
		}
		return renderAccount();
	}
});

const StyledDisabledOutputText = styled(OutputText)`
	&.disabled {
		color: var(--disabled);
	}
`;
